import debugT from 'debug';
import rg from 'modules/npm-component/require-global';
import Batch from 'batch';
import _ from 'lodash';
import FeaturesPartial from 'components/pricingPlans/vendor/partials/features/features-partial';
import PricingPartial from 'components/pricingPlans/vendor/partials/pricing-partial';
import ContactForm from 'auth0-contact-form';
import metrics from 'modules/metrics';
import tip from 'component-tip';
import $ from 'jquery';

const debug = debugT('auth0:pricing-module');

const metricsLib = window.metricsLib;
const mouseFlow = window.mouseflow || undefined;

const track = function(eventName, props) {
  debug('track', eventName, props);
  metrics.lib().track(
    eventName,
    _.extend(
      {
        category: 'pricing'
      },
      props
    )
  );
};

const featuresPartial = new FeaturesPartial({ track });

const pricingPartial = new PricingPartial({ featuresPartial, track });

export default function PricingScripts(options) {
  options = options || {};

  if (!('ontouchstart' in window)) {
    $('[data-toggle="tooltip"]').tooltip();
  }
}

PricingScripts.prototype.loadScripts = function(ctx, next) {
  const batch = new Batch();

  pricingPartial.load(batch);
  featuresPartial.load(batch);

  batch.push(done => {
    rg('https://cdn.auth0.com/website/assets/pages/pricing/resources/tooltips-a344d1455d.min.js', '$.fn.tooltips', done);
  });

  batch.push(done => {
    rg('https://cdn.auth0.com/website/assets/pages/pricing/resources/modal-3af0dc2fc3.min.js', '$.fn.modal', done);
  });

  batch.end(next);
};

PricingScripts.prototype.renderPricing = function(ctx, next) {
  pricingPartial.activate();
  pricingPartial.render();
  next();
};

PricingScripts.prototype.renderFeatures = function(ctx, next) {
  featuresPartial.activate();
  $('.js-plan-features-container').each(function() {
    const plan = this.getAttribute('data-plan');
    featuresPartial.render(plan);
  });
  // enable tooltips only in desktop view
  if (!('ontouchstart' in window)) {
    $('[data-toggle="tooltip"]').tooltip({ container: 'body' });
  }
  next();
};

PricingScripts.prototype.snippets = function(ctx, next) {
  const $featuresSwitch = $('.features-switch-cont');

  $(window).scroll();

  // Switch functionality
  $featuresSwitch.on('click', function(e) {
    $(this).find('.active').removeClass('active');
    $(e.target).addClass('active');
  });

  $('.switch-plan[data-view="fixed-plans"] .switch-item').click(ev => {
    ev.preventDefault();
    toggleSwitcher($('.switch-plan[data-view="fixed-plans"] .switch-item:not(.active)'));
  });

  $('.switch-plan[data-view="fixed-plans"] .switch-item').click(function(ev) {
    ev.preventDefault();
    if ($(this).hasClass('active')) return;
    toggleSwitcher(this);
  });

  tip('.package-plan-tip');

  $('.js-general-contact-sales').click(() => {
    track('click:contact-sales');
  });

  // Developer Pro Internal-External Switch
  $(".plan-usage-toggle input[type='radio']").change(function() {
    const value = $(this).val();
    $('.developer-pro-external,.developer-pro-internal').toggleClass('hide', true);
    $(`.developer-pro-${value}`).toggleClass('hide', false);
    $('[name="usage"]').prop('checked', false);
    $(`[name="usage"][value="${value}"]`).prop('checked', function() {
      return $(this).parent().is(':visible');
    });
  });

  contactFormModalsPlans();

  return next();
};

function contactFormModalsPlans() {
  // Contact OSS Form
  const ossContactFormOptions = {
    onModalOpen() {
      metricsLib.track('click:contact-oss');
    },
    onFormSuccess(metricsData) {
      metricsLib.track('register:lead:pricing-contact-form-oss', metricsData);
      mouseFlow ? mouseFlow.formSubmitSuccess('#contact-form-modal__form') : null;
    },
    onFormFail(metricsData) {
      metricsLib.track('fail:register:lead:pricing-contact-form-oss', metricsData);
      mouseFlow ? mouseFlow.formSubmitFailure('#contact-form-modal__form') : null;
    },
    modalTitle: 'Contact OSS team',
    source: 'oss'
  };
  const ossContactForm = new ContactForm(ossContactFormOptions);

  $('.open-contact-oss').click(() => ossContactForm.show({ includePhoneField: true }));
}

function toggleSwitcher(el) {
  if ($(el).hasClass('active')) return;

  // toggle buttons
  $('.switch-plan[data-view="fixed-plans"] .switch-item').removeClass('active');
  $(el).addClass('active');

  pricingPartial.setRecurrence($(el).data('interval'));
}



// WEBPACK FOOTER //
// ./src/components/pricingPlans/vendor/index.js